import { Flex } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { CancelButton, SaveButton } from "components/Products/EditPanelContent";
import SkuBrandOrderingPlatformForm from "components/Customers/CustomerPage/ProductDetails/Form";
import useEditSkuBrandOrderingPlatform from "components/Customers/CustomerPage/ProductDetails/useEdit";

const fragment = gql(/* GraphQL */ `
  fragment EditSkuOrderingPlatform on SkuBrandOrderingPlatform {
    id
    ...UseEditSkuBrandOrderingPlatform
  }
`);

type Props = {
  onCancel?: () => void;
  onCompleted?: () => void;
  skuBrandOrderingPlatform: FragmentType<typeof fragment>;
};

export default function SkuOrderingPlatformEdit({
  onCancel,
  onCompleted,
  skuBrandOrderingPlatform: skuBrandOrderingPlatformFragment,
}: Props) {
  const sbop = getFragmentData(fragment, skuBrandOrderingPlatformFragment);

  const {
    brandOrderingPlatformId,
    defaultValues,
    handleValidSubmit,
    isUpdating,
    skuId,
  } = useEditSkuBrandOrderingPlatform(sbop, {
    successMessage: "Customer details updated successfully.",
    onUpdateComplete: onCompleted,
  });

  return (
    <SkuBrandOrderingPlatformForm
      skuId={skuId}
      brandOrderingPlatformId={brandOrderingPlatformId}
      defaultValues={defaultValues}
      onValidSubmit={handleValidSubmit}
      isSkuHidden
      isBrandOrderingPlatformHidden
      footer={
        <Flex justifyContent="flex-end" mt={4} gap={3}>
          <CancelButton onClick={onCancel} size="sm" />
          <SaveButton size="sm" isLoading={isUpdating} />
        </Flex>
      }
    />
  );
}
